import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '热门推荐', path: '/#hot-comics' },
      { name: '最新文章', path: '/#latest-articles' },
      { name: '关于我们', path: '/about' },
    ],
  },
  {
    title: '漫画分类',
    links: [
      { name: '恋爱漫画', path: '/#categories' },
      { name: '奇幻漫画', path: '/#categories' },
      { name: '动作漫画', path: '/#categories' },
      { name: '校园漫画', path: '/#categories' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '用户口碑', path: '/about#reputation' },
      { name: '联系我们', path: '/about#contact' },
      { name: '常见问题', path: '/#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-white">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
                </div>
                <span className="text-lg font-bold font-heading">韩漫世界</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                免费韩国漫画在线阅读平台。海量韩漫资源，流畅的下拉式阅读体验，无需注册，随时随地感受韩漫的魅力。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold mb-4 text-background-100">{group.title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2026 韩漫世界 - 免费韩漫在线阅读平台。本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
              </a>
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-weibo-line text-lg"></i>
                </div>
              </a>
              <a href="#" className="text-background-400 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-bilibili-line text-lg"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}